import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import { languages } from "../../constants/languages";
import Checkbox from "@material-ui/core/Checkbox";
import FileUploader from "react-firebase-file-uploader";
import EditTeamContainer from "../../containers/teams/EditTeamContainer";
import EditPlayersContainer from "../../containers/teams/EditPlayersContainer";
import EditRefereeContainer from "../../containers/schedule/EditRefereeContainer";
import EditAdminContainer from "../../containers/admins/EditAdminContainer";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import UploadIcon from "@material-ui/icons/CloudUpload";
import moment from "moment-timezone";
import "flag-icon-css/css/flag-icon.css";
import DefaultInfoFieldsReferees from "../../constants/DefaultInfoFieldsReferees";
import InfoIcon from "@material-ui/icons/Info";
import CopyIcon from "@material-ui/icons/FileCopy";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import red from "@material-ui/core/colors/red";
import { copyToClipboard } from "../../util/CopyToClipboard";

const TeamsTableRow = (props) => (
  <TableRow
    hover
    role="checkbox"
    aria-checked={props.isSelected}
    tabIndex={-1}
    key={props.team.id}
    selected={props.isSelected}
  >
    <TableCell padding="checkbox">
      <Checkbox
        checked={props.isSelected}
        onClick={(event) => props.handleClick(event, props.team)}
        color="primary"
      />
    </TableCell>
    {(((props.tournament.defaultFields || {})["present"] || {}).show ||
      props.tournament.requireCheckIn) &&
      !props.refereesPage &&
      !props.adminsPage && (
        <TableCell style={{ padding: "6px 0px 6px 0px" }}>
          <Checkbox
            checked={props.team.present || false}
            onClick={(event) => {
              props.handleCheck(event, "present");
            }}
            style={{ padding: 0 }}
            color="primary"
          />
        </TableCell>
      )}
    {((props.tournament.defaultFields || {})["payed"] || {}).show &&
      !props.refereesPage &&
      !props.adminsPage && (
        <TableCell style={{ padding: "6px 0px 6px 0px" }}>
          <Checkbox
            checked={props.team.payed || false || props.payed}
            onClick={(event) => {
              props.handleCheck(event, "payed");
            }}
            style={{ color: props.payed ? "#c06" : "green", padding: 0 }}
            disabled={props.payed}
          />
        </TableCell>
      )}
    <TableCell
      style={{
        fontWeight: props.orderBy === "name" ? 500 : "",
        whiteSpace: "nowrap",
      }}
    >
      {props.team.name}
    </TableCell>
    {/* {(((props.tournament.defaultFields || {})["extraField"] || {}).show ===
      undefined ||
      ((props.tournament.defaultFields || {})["extraField"] || {}).show) && (
      <TableCell
        padding="none"
        style={{
          fontWeight: props.orderBy === "extraField" ? 500 : ""
        }}
      >
        {props.team.extraField}
      </TableCell>
    )} */}
    {(((props.tournament.defaultFields || {})["email"] || {}).show ||
      (((props.tournament.defaultFields || {})["email"] || {}).show ===
        undefined &&
        (props.tournament.signupOpen || false))) &&
      !props.refereesPage &&
      !props.adminsPage && (
        <TableCell
          style={{
            fontWeight: props.orderBy === "email" ? 500 : "",
          }}
        >
          {props.team.email || ""}
        </TableCell>
      )}
    {((props.tournament.defaultFields || {})["added"] || {}).show &&
      !props.refereesPage &&
      !props.adminsPage && (
        <TableCell
          style={{
            fontWeight: props.orderBy === "added" ? 500 : "",
            whiteSpace: "nowrap",
          }}
        >
          {props.team.added &&
            moment.unix(props.team.added).format(languages.teams.dateFormat)}
        </TableCell>
      )}
    {((props.tournament.defaultFields || {})["country"] || {}).show &&
      !props.refereesPage &&
      !props.adminsPage && (
        <TableCell>
          {props.gbFlag ? (
            <img
              src={props.gbFlag}
              alt="flag"
              style={{ height: 14, width: 19 }}
            />
          ) : (
            <span
              className={
                "flag-icon flag-icon-" +
                (props.team.country || "none").toLowerCase()
              }
            />
          )}
        </TableCell>
      )}

    {((props.tournament.defaultFields || {})["refereeCountry"] || {}).show &&
      props.refereesPage &&
      !props.adminsPage && (
        <TableCell>
          {props.gbFlag ? (
            <img
              src={props.gbFlag}
              alt="flag"
              style={{ height: 14, width: 19 }}
            />
          ) : (
            <span
              className={
                "flag-icon flag-icon-" +
                (props.team.country || "none").toLowerCase()
              }
            />
          )}
        </TableCell>
      )}

    {/* PSD ecup */}
    {props.tournament[".key"] === "G64irmoaJPIkFfYKkfUP" && (
      <TableCell>{props.psdClubTeam}</TableCell>
    )}

    {(((props.tournament.defaultFields || {})["logo"] || {}).show ||
      (props.tournament.defaultFields || {})["logo"] === undefined) &&
      !props.refereesPage &&
      !props.adminsPage && (
        <TableCell>
          <FileUploader
            id={"teamLogoRow-" + props.team.id}
            style={{ display: "none" }}
            accept="image/*"
            name="teamLogo"
            randomizeFilename
            storageRef={props.logoStorageRef}
            beforeUploadStart={(file) => {
              props.validateFileSize(file, 1);
            }}
            onUploadStart={props.handleLogoUploadStart}
            onUploadError={props.handleLogoUploadError}
            onUploadSuccess={props.handleLogoUploadSuccess}
          />
          {props.isUploadingLogo ? (
            <CircularProgress size={16} />
          ) : props.team.logo ? (
            <label
              htmlFor={"teamLogoRow-" + props.team.id}
              style={{ cursor: "pointer", display: "inline-flex", verticalAlign: "middle" }}
            >
              <img
                src={props.team.logo || ""}
                alt=""
                title={languages.teams.change}
                style={{ maxHeight: 24, maxWidth: 24, marginRight: 4, display: "block" }}
              />
            </label>
          ) : (
            <label
              htmlFor={"teamLogoRow-" + props.team.id}
              style={{ cursor: "pointer", display: "inline-flex", verticalAlign: "middle" }}
            >
              <UploadIcon style={{ fontSize: 18, color: "rgba(0, 0, 0, 0.54)" }} />
            </label>
          )}
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={props.logoUploadToastOpen}
            autoHideDuration={3000}
            onClose={props.onLogoUploadToastClose}
          >
            <SnackbarContent
              style={{ backgroundColor: red[700], color: "#fff" }}
              message={
                <span id={"team-logo-upload-error-" + props.team.id}>{props.logoUploadToastMessage}</span>
              }
            />
          </Snackbar>
        </TableCell>
      )}

    {((props.tournament.defaultFields || {})["dressingRoom"] || {}).show &&
      !props.refereesPage &&
      !props.adminsPage && (
        <TableCell>{props.team.dressingRoom || ""}</TableCell>
      )}

    {(((props.tournament.defaultFields || {})["players"] || {}).show ||
      (props.tournament.defaultFields || {})["players"] === undefined) &&
      !props.refereesPage &&
      !props.adminsPage &&
      !props.tournament.individualPlayers && (
        <TableCell>
          <EditPlayersContainer
            tournament={props.tournament}
            players={props.players}
            division={props.division}
            team={props.team}
            playersContactInfo={props.playersContactInfo}
            playersContactInfoLoaded={props.playersContactInfoLoaded}
          />
        </TableCell>
      )}

    {((((props.tournament.defaultFields || {})["shareURL"] || {}).show &&
      !props.adminsPage && !props.refereesPage) ||
      ((((props.tournament.defaultFields || {})["refereeShareURL"] || {})
        .show ||
        ((props.tournament.defaultFields || {})["refereeShareURL"] || {})
          .show === undefined) &&
        props.refereesPage &&
        !props.adminsPage)) && (
      <TableCell
        onMouseEnter={() => {
          props.showCopyButton(true);
        }}
        onMouseLeave={() => {
          props.showCopyButton(false);
        }}
        style={{ overflow: "hidden" }}
      >
        {props.tournament.liveLink ? (
          props.code ? (
            <div style={{ width: 150, display: "flex", alignItems: "middle" }}>
              <div
                style={{
                  width: 120,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {props.code}
              </div>
              <div style={{ width: 30, height: 20 }}>
                {props.copyButton && (
                  <Tooltip title={languages.general.copy} placement="top">
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        copyToClipboard("https://" + props.code);
                      }}
                    >
                      {/* <IconButton
                          disabled
                          style={{
                            width: 17,
                            height: 17,
                          }}
                        > */}
                      <CopyIcon
                        style={{
                          height: 17,
                          color: "#757575",
                          position: "relative",
                          top: 2,
                        }}
                      />
                      {/* </IconButton> */}
                    </span>
                  </Tooltip>
                )}
              </div>
            </div>
          ) : props.codeLoaded ? (
            <Tooltip
              title={languages.formatString(
                languages.teamInfo.addTeamAgain,
                props.tournament.individualPlayers
                  ? languages.teams.playerLow
                  : languages.results.teamLow
              )}
              placement="top"
            >
              <span>
                {/* <IconButton
                    disabled
                    edge="end"
                    style={{
                      width: 30,
                      height: 30,
                      bottom: 7,
                      display: "inline",
                    }}
                  > */}
                <InfoIcon
                  style={{
                    height: 17,
                    color: "#757575",
                    position: "relative",
                    top: 2,
                  }}
                />
                {/* </IconButton> */}
              </span>
            </Tooltip>
          ) : (
            ""
          )
        ) : (
          <Tooltip
            title={languages.teamInfo.shareURLDescription3}
            placement="top"
          >
            <span>
              {/* <IconButton
                  disabled
                  edge="end"
                  style={{
                    width: 30,
                    height: 30,
                    bottom: 7,
                    display: "inline",
                  }}
                > */}
              <InfoIcon
                style={{
                  height: 17,
                  color: "#757575",
                  position: "relative",
                  top: 2,
                }}
              />
              {/* </IconButton> */}
            </span>
          </Tooltip>
        )}
      </TableCell>
    )}

    {((props.tournament.defaultFields || {})["language"] || {}).show &&
      (props.tournament.lang || []).length > 1 &&
      !props.refereesPage &&
      !props.adminsPage && (
        <TableCell
          style={{
            fontWeight: props.orderBy === "language" ? 500 : "",
          }}
        >
          {props.language || ""}
        </TableCell>
      )}

    {!props.refereesPage &&
      !props.adminsPage &&
      (props.tournament.showTeamSignupQuestion2Table !== undefined
        ? props.tournament.showTeamSignupQuestion2Table
        : props.tournament.showTeamSignupQuestion2 !== undefined
        ? props.tournament.showTeamSignupQuestion2
        : false) && (
        <TableCell
          style={{
            fontWeight: props.orderBy === "gamertag" ? 500 : "",
            whiteSpace: "nowrap",
          }}
        >
          {props.team["gamertag"] || ""}
        </TableCell>
      )}

    {!props.refereesPage &&
      !props.adminsPage &&
      Object.keys(props.tournament.questions || {})
        .filter((key) => props.tournament.questions[key].perSignup !== true)
        .sort((a, b) => {
          const qA = props.tournament.questions[a];
          const qB = props.tournament.questions[b];
          if (qA.num > qB.num) {
            return 1;
          } else if (qA.num < qB.num) {
            return -1;
          } else {
            return 0;
          }
        })
        .map((key) => {
          let question = props.tournament.questions[key];
          let answer = (props.team.questions || {})[key] || "";
          return question.show ? (
            <TableCell
              key={key}
              style={{
                fontWeight: props.orderBy === key ? 500 : "",
                whiteSpace: "nowrap",
              }}
            >
              {question.type === "0"
                ? answer
                : (question.choices || {})[answer] || ""}
            </TableCell>
          ) : null;
        })}

    {!props.refereesPage &&
      !props.adminsPage &&
      Object.keys(props.tournament.questions || {})
        .filter((key) => props.tournament.questions[key].perSignup === true)
        .sort((a, b) => {
          const qA = props.tournament.questions[a];
          const qB = props.tournament.questions[b];
          if (qA.num > qB.num) {
            return 1;
          } else if (qA.num < qB.num) {
            return -1;
          } else {
            return 0;
          }
        })
        .map((key) => {
          let question = props.tournament.questions[key];
          let answer = (props.team.questions || {})[key] || "";
          return question.show ? (
            <TableCell
              key={key}
              style={{
                fontWeight: props.orderBy === key ? 500 : "",
                whiteSpace: "nowrap",
              }}
            >
              {question.type === "0"
                ? answer
                : (question.choices || {})[answer] || ""}
            </TableCell>
          ) : null;
        })}

    {!props.refereesPage &&
      !props.adminsPage &&
      Object.keys(props.tournament.products || {})
        .filter((p) => !props.tournament.products[p].alwaysAdd)
        .sort((a, b) => {
          const pA = props.tournament.products[a];
          const pB = props.tournament.products[b];
          if (pA.num > pB.num) {
            return 1;
          } else if (pA.num < pB.num) {
            return -1;
          } else {
            return 0;
          }
        })
        .map((key) => {
          let product = props.tournament.products[key];
          let number = (props.team.products || {})[key] || "";
          return product.show || product.show === undefined ? (
            <TableCell
              key={key}
              style={{
                fontWeight: props.orderBy === key ? 500 : "",
              }}
            >
              {number && "x" + number}
            </TableCell>
          ) : null;
        })}

    {!props.refereesPage &&
      !props.adminsPage &&
      Object.keys(props.tournament.infoFields || {}).map((key) => {
        let value = props.team[key] || "";
        return (
          <TableCell
            key={key}
            style={{
              fontWeight: props.orderBy === key ? 500 : "",
            }}
          >
            {value}
          </TableCell>
        );
      })}

    {!props.refereesPage &&
      !props.adminsPage &&
      props.days.length > 2 &&
      ["prefer", "preferNot", "notAvailable"]
        .filter((p) => ((props.tournament.teamWishes || {})[p] || {}).show)
        .map((key) => {
          let day = (props.team.teamWishes || {})[key] || "";
          return (
            <TableCell
              key={key}
              style={{
                fontWeight: props.orderBy === key ? 500 : "",
              }}
            >
              {day
                ? [
                    languages.schedule.empty,
                    languages.days.mon,
                    languages.days.tue,
                    languages.days.wed,
                    languages.days.thu,
                    languages.days.fri,
                    languages.days.sat,
                    languages.days.sun,
                  ][day]
                : ""}
            </TableCell>
          );
        })}

    {props.refereesPage &&
      Object.keys(DefaultInfoFieldsReferees).map((key) => {
        let show = ((props.tournament.defaultFieldsReferees || {})[key] || {})
          .show;
        if (show === undefined) {
          show = false;
        }
        return show ? (
          <TableCell
            key={key}
            style={{
              fontWeight: props.orderBy === key ? 500 : "",
            }}
          >
            {key === "location" &&
              props.sportParks.map((s) => {
                let value = (props.team[key] || {})[s.id];
                let valueString = languages.referees.allFields;
                if (value === undefined) {
                  value = "all";
                }
                if (value === "none") {
                  valueString = languages.referees.none;
                }
                if (value !== "all" && value !== "none") {
                  let fieldsNames = [];
                  value.forEach((f) => {
                    let field =
                      ((props.tournament.fields || {})[f] || {}).name || "";
                    fieldsNames.push(field);
                  });
                  valueString = fieldsNames.join(", ");
                }
                return (
                  <div key={s.id}>
                    {props.sportParks.length > 1 && (
                      <span>{s.name + ": "}</span>
                    )}
                    {valueString}
                  </div>
                );
              })}
            {key === "time" &&
              [{ id: "0", date: props.tournament.date }]
                .concat(props.days)
                .map((d) => {
                  let value = (props.team["availability"] || {})[d.id];
                  let valueString = languages.referees.allDay;
                  if (value === undefined) {
                    value = "all";
                  }
                  if (value === "none") {
                    valueString = languages.referees.notAvailable;
                  }
                  if (value !== "all" && value !== "none") {
                    valueString =
                      (value.start ? languages.referees.from + " " : "") +
                      (value.start || "") +
                      " " +
                      (value.end ? languages.referees.until + " " : "") +
                      " " +
                      (value.end || "");
                  }
                  return (
                    <div key={d.id}>
                      {props.days.length > 0 && (
                        <span>
                          {moment
                            .unix(d.date)
                            .tz(props.tournament.timezone || "Europe/Amsterdam")
                            .format(languages.createTournament.dateFormat) +
                            ": "}
                        </span>
                      )}
                      {valueString}
                    </div>
                  );
                })}
            {key === "divisions" && props.divisionsString}
            {key === "maxMatches" &&
              (props.team["maxMatches"] || languages.referees.noLimit)}
            {key === "excludeTeams" && props.teamsString}
            {key === "role" && props.rolesString}
          </TableCell>
        ) : null;
      })}
    {props.refereesPage &&
      Object.keys(props.tournament.infoFieldsReferees || {}).map((key) => {
        return (
          <TableCell
            key={key}
            style={{
              fontWeight: props.orderBy === key ? 500 : "",
            }}
          >
            {props.team[key] || ""}
          </TableCell>
        );
      })}
    {props.adminsPage &&
      [
        "manageGeneral",
        "manageTeams",
        "manageFormat",
        "manageSchedule",
        "managePresentation",
        "managePublicWebsite",
        "manageSlideshow",
        "manageDesign",
        "manageResults",
        "managePhases",
      ].map((key) => {
        let trueOrFalse = props.team[key] || false;
        if (
          key === "managePublicWebsite" ||
          key === "manageSlideshow" ||
          key === "manageDesign"
        ) {
          trueOrFalse =
            (props.team[key] || false) &&
            (props.team["managePresentation"] || false);
        }
        if (key === "managePhases") {
          trueOrFalse =
            (props.team[key] || false) &&
            (props.team["manageResults"] || false);
        }
        return (
          <TableCell
            key={key}
            style={{
              fontWeight: props.orderBy === key ? 500 : "",
            }}
          >
            {trueOrFalse ? (
              <CheckCircleIcon style={{ color: "green", height: 18 }} />
            ) : (
              <RemoveCircleIcon style={{ color: "red", height: 18 }} />
            )}
          </TableCell>
        );
      })}

    <TableCell align="right">
      {!props.refereesPage && !props.adminsPage && (
        <Tooltip title={languages.teams.change}>
          {props.team ? <EditTeamContainer {...props} /> : <div />}
        </Tooltip>
      )}
      {props.refereesPage && (
        <Tooltip title={languages.teams.change}>
          <EditRefereeContainer
            tournament={props.tournament}
            referee={props.team}
            sportParks={props.sportParks}
            days={props.days}
            divisions={props.divisions}
            allTeams={props.allTeams}
            allTeamsByKey={props.allTeamsByKey}
          />
        </Tooltip>
      )}
      {props.adminsPage && (
        <Tooltip title={languages.teams.change}>
          <EditAdminContainer
            tournament={props.tournament}
            admin={props.team}
          />
        </Tooltip>
      )}
    </TableCell>
  </TableRow>
);

export default TeamsTableRow;
